/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<circle
				opacity="0.4"
				cx="12"
				cy="13"
				r="4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 9.38747C2 7.4178 3.39027 5.72195 5.32169 5.33566L5.45748 5.3085C6.44514 5.11097 7.31388 4.52918 7.87258 3.69113V3.69113C8.57693 2.6346 9.7627 2 11.0325 2H12.9675C14.2373 2 15.4231 2.6346 16.1274 3.69113V3.69113C16.6861 4.52918 17.5549 5.11097 18.5425 5.3085L18.6783 5.33566C20.6097 5.72195 22 7.4178 22 9.38747V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V9.38747Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.87258 3.69113C7.31388 4.52919 6.44514 5.11097 5.45748 5.30851L5.32169 5.33566C3.39027 5.72195 2 7.4178 2 9.38747L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9.38747C22 7.4178 20.6097 5.72195 18.6783 5.33566L18.5425 5.30851C17.5549 5.11097 16.6861 4.52919 16.1274 3.69113C15.4231 2.63461 14.2373 2 12.9675 2L11.0325 2C9.7627 2 8.57693 2.6346 7.87258 3.69113ZM12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z"
				fill="currentColor"
			/>
			<path
				d="M2 9.38747C2 7.4178 3.39027 5.72195 5.32169 5.33566L5.45748 5.3085C6.44514 5.11097 7.31388 4.52918 7.87258 3.69113V3.69113C8.57693 2.6346 9.7627 2 11.0325 2H12.9675C14.2373 2 15.4231 2.6346 16.1274 3.69113V3.69113C16.6861 4.52918 17.5549 5.11097 18.5425 5.3085L18.6783 5.33566C20.6097 5.72195 22 7.4178 22 9.38747V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V9.38747Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 13C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13C8 10.7909 9.79086 9 12 9C14.2091 9 16 10.7909 16 13Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.02315 4.63052C5.99968 4.43521 6.85862 3.85998 7.41103 3.03137L7.44282 2.98368C8.1649 1.90057 9.3805 1.25 10.6822 1.25L13.3178 1.25C14.6195 1.25 15.8351 1.90057 16.5572 2.98368L16.589 3.03137C17.1414 3.85998 18.0003 4.43521 18.9769 4.63052C21.1708 5.0693 22.75 6.99565 22.75 9.23302V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75L1.25 9.23302C1.25 6.99565 2.82922 5.0693 5.02315 4.63052ZM12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 10.5V9.38747C2 7.4178 3.39027 5.72195 5.32169 5.33566L5.45748 5.3085C6.44514 5.11097 7.31388 4.52918 7.87258 3.69113V3.69113C8.57693 2.6346 9.7627 2 11.0325 2H12.9675C14.2373 2 15.4231 2.6346 16.1274 3.69113V3.69113C16.6861 4.52918 17.5549 5.11097 18.5425 5.3085L18.6783 5.33566C20.6097 5.72195 22 7.4178 22 9.38747V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H8.5C7.10547 22 6.40821 22 5.83277 21.8618C4.00453 21.4229 2.57707 19.9955 2.13815 18.1672C2 17.5918 2 16.8945 2 15.5V15.5V15M12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13C16 12.2714 15.8052 11.5883 15.4649 11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 9.38747C2 7.4178 3.39027 5.72195 5.32169 5.33566L5.45748 5.3085C6.44514 5.11097 7.31388 4.52918 7.87258 3.69113V3.69113C8.57693 2.6346 9.7627 2 11.0325 2H12.9675C14.2373 2 15.4231 2.6346 16.1274 3.69113V3.69113C16.6861 4.52918 17.5549 5.11097 18.5425 5.3085L18.6783 5.33566C20.6097 5.72195 22 7.4178 22 9.38747V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V9.38747Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 13C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13C8 10.7909 9.79086 9 12 9C14.2091 9 16 10.7909 16 13Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.02315 4.63052C5.99968 4.43521 6.85862 3.85998 7.41103 3.03137L7.44282 2.98368C8.1649 1.90057 9.3805 1.25 10.6822 1.25L13.3178 1.25C14.6195 1.25 15.8351 1.90057 16.5572 2.98368L16.589 3.03137C17.1414 3.85998 18.0003 4.43521 18.9769 4.63052C21.1708 5.0693 22.75 6.99565 22.75 9.23302V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75L1.25 9.23302C1.25 6.99565 2.82922 5.0693 5.02315 4.63052Z"
				fill="currentColor"
			/>
			<path
				d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
